export default __webpack_public_path__ + "static/media/tk.75a45a1b.svg";